// 2026-09-11: Top-bar sticky que muestra "Venís por X" en la tienda.
// - Se monta una vez en App.jsx, arriba de <Routes>.
// - No se muestra en rutas internas (admin, panel, vendedor, repartidor, cliente).
// - Solo aparece si el cliente llegó por el link/QR en ESTA sesión de navegación
//   (sessionStorage). La atribución al pedido sigue funcionando por 30 días
//   vía localStorage — pero el banner no lo persigue en visitas posteriores.
// - Como es sticky top:0, empuja el contenido hacia abajo naturalmente.

import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { getRefSession } from '../lib/utm'

const HIDE_PREFIXES = [
  '/admin',
  '/panel',
  '/vendedor',
  '/repartidor',
  '/cliente',
  '/porteros-panel',
  '/auth',
  '/invitar',
]

export default function RefBanner() {
  const [ref, setRef] = useState(null)
  const location = useLocation()

  // Refrescar el ref en cada cambio de ruta (por si captura recién ocurre después
  // del primer render, o si el user navegó a otra URL con ?ref=X distinto).
  useEffect(() => {
    setRef(getRefSession())
  }, [location.pathname, location.search])

  if (!ref) return null

  const path = location.pathname || '/'
  if (HIDE_PREFIXES.some(p => path === p || path.startsWith(p + '/'))) return null

  const nombre = String(ref).toUpperCase()

  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        background: 'linear-gradient(135deg, #00A8B5 0%, #1A5CB8 100%)',
        color: '#fff',
        padding: '10px 16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 10,
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1.35,
        textAlign: 'center',
        boxShadow: '0 2px 10px rgba(0,168,181,0.3)',
        fontFamily: 'Inter, system-ui, sans-serif',
      }}
    >
      <span style={{ fontSize: 18, flexShrink: 0 }} aria-hidden="true">🎁</span>
      <span>
        Venís por <strong style={{ fontWeight: 800 }}>{nombre}</strong>
        <span style={{ opacity: 0.9, fontWeight: 500 }}> · 10% off en compras mayores a $1500 · transferencia bancaria habilitada</span>
      </span>
    </div>
  )
}
